import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import ReactOwlCarousel from "react-owl-carousel";
import { Link } from "react-router-dom";
import { useApp } from "../../context/AppContextProvider";
import { enviroment } from "../../enviroment";
import ApiService from "../../services/ApiService";
import { ProductCard } from "../ProductCard/ProductCard";
// Import JsonLd from react-schemaorg
import { JsonLd } from "react-schemaorg";

export const HomeCategories = () => {
    const appData = useApp();
    let windowWidth = appData.appData.windowWidth;
    const [categoriesData, setCategoriesData] = useState([]);
    const isMobile = windowWidth === "mobile";

    useEffect(() => {
        const payload = {
            company_id: parseInt(enviroment.COMPANY_ID),
            store_id: parseInt(enviroment.STORE_ID),
        };
        ApiService.homeCategories(payload)
            .then((res) => {
                setCategoriesData(res.payload);
            })
            .catch((err) => { });
    }, []);

    const carouselOptions = {
        margin: isMobile ? 10 : 20,
        dots: false,
        nav: true,
        loop: categoriesData.length > (isMobile ? 1 : 4),
        items: isMobile ? 1 : 4,
        stagePadding: isMobile ? 40 : 0,
        responsive: {
            0: { items: 1.5, stagePadding: 40 },
            576: { items: 2, stagePadding: 30 },
            768: { items: 3, stagePadding: 20 },
            992: { items: 3, stagePadding: 0 },
            1200: { items: 4, stagePadding: 0 },
        },
        touchDrag: true,
        mouseDrag: true,
        smartSpeed: 750,
    };

    return (
        <>
            {/* Add ItemList Schema for Categories */}
            {categoriesData?.length > 0 && (
                <JsonLd
                    item={{
                        "@context": "https://schema.org",
                        "@type": "ItemList",
                        name: "Shop Categories",
                        description: "Browse products by category on our store homepage.",
                        url: window.location.href,
                        itemListElement: categoriesData.map((category, index) => ({
                            "@type": "ListItem",
                            position: index + 1,
                            item: {
                                "@type": "Thing", // Could use "ProductCategory" if custom type is supported, but "Thing" is generic
                                name: category?.cname || "",
                                url: `${window.location.origin}/store-product/${category?.cname_url}`,
                                description: `Explore products in the ${category?.cname} category.`,
                            },
                        })),
                    }}
                />
            )}

            {categoriesData?.length > 0 &&
                categoriesData.map((category, index) => {
                    const isActive = index === 1;
                    return <React.Fragment key={index}>
                        <div className="border-section my-2 py-2" style={{
                            backgroundColor: isActive ? 'var(--PRIMARY_COLOR)' : 'inherit'
                        }}>
                            <div className={`col-12 d-inline-flex`}>
                                <div className={`container-md-fluid container py-0`}>
                                    <div
                                        className={`col-12 ${windowWidth === "mobile" ? "px-0" : "m-0"
                                            } d-inline-flex flex-column`}
                                    >
                                        <div className="titlesWrapper">
                                            <p className={`subTitleLarge col-12 m-0 ${isActive ? 'text-white' : ''}`} style={{
                                                fontSize: '22px'
                                            }}>{category?.cname}</p>
                                        </div>
                                        <ReactOwlCarousel className="owl-theme" {...carouselOptions}>
                                            {category?.products.map((item, idx) => (
                                                <div
                                                    key={idx}
                                                    className="item"
                                                    style={{
                                                        padding: "25px 0px",
                                                        transition: "transform 0.3s",
                                                        cursor: "pointer",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.transform = "scale(1.05)";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.transform = "scale(1)";
                                                    }}
                                                >
                                                    <ProductCard item={item} index={idx} />
                                                </div>
                                            ))}
                                        </ReactOwlCarousel>
                                        <Link
                                            to={`/store-product/${category?.cname_url}`}
                                            className="w-fit mt-3 mx-auto"
                                        >
                                            <Button className={`titleMainSmall-2 ${isActive ? "btn-special-2" : "btn-special"} p-2 px-5 ${isActive ? 'text-white ' : ''
                                                }`}>
                                                Explore More
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <style jsx>{`
                .owl-nav {
                    position: absolute;
                    top: 50%;
                    width: 100%;
                    transform: translateY(-50%);
                    display: flex;
                    justify-content: space-between;
                    pointer-events: none;
                }
                .owl-nav button {
                    pointer-events: auto;
                    background: rgba(255, 255, 255, 0.8) !important;
                    padding: 0px !important;
                    width: 45px !important;
                    height: 45px !important;
                    border-radius: 100% !important;
                    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
                    transition: all 0.3s ease;
                }
                @media (max-width: 576px) {
                    .owl-prev {
                    margin-left: -20px;
                    }
                    .owl-next {
                    margin-right: -20px;
                    }
                }
            `}</style>
                    </React.Fragment>
                })}
        </>
    );
};